import productTransformer from '@/events/dataLayerBasic/transformers/product.transformer'

export default ({ eventBus, eventDefinitions, context }) => {
  eventBus.$on(
    eventDefinitions.SEARCH.RESULTS,
    ({ query, location, items = [], productTeaser = false, type = null }) => {
      const minChars = context.app.$contentSettings.events.dataLayerBasic.searchQuery.minimumCharacters || 0
      if (!query || query.length < minChars) return

      const isCategoryClick =
        type === 'category' ||
        (Array.isArray(items) &&
          items.length > 0 &&
          items.every(i => i?.type === 'category' || (!!i?.id && !!i?.title && !!i?.path && !i?.product)))

      if (isCategoryClick) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'search_results',
          search_detail: {
            search_term: query,
            page_type: location,
            mkt_val_all: 0,
            currency: 'CZK',
            items: [],
            google_tag_params: {
              ecomm_pagetype: location,
              ecomm_prodid: [],
              ecomm_totalvalue: 0,
              ecomm_totalvalue_all: [],
            },
          },
        })
        return
      }

      const transformedItems = items.map((item, index) => {
        const product = productTeaser ? item : item.product
        return productTransformer(product, 1, 0, 0, index)
      })

      const mktValAll = transformedItems.reduce((sum, it) => sum + it.price * it.quantity, 0)
      const totalValue = mktValAll

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'search_results',
        search_detail: {
          search_term: query,
          page_type: location,
          mkt_val_all: mktValAll,
          currency: 'CZK',
          items: transformedItems,
          google_tag_params: {
            ecomm_pagetype: location,
            ecomm_prodid: transformedItems.map(it => String(it.item_id)),
            ecomm_totalvalue: totalValue,
            ecomm_totalvalue_all: transformedItems.map(it => it.price * it.quantity),
          },
        },
      })
    },
  )
}
